import { EcardDesignInputFields } from '@shared/components/EmailsAndEcards/components/Design/Design.controller';
import { EcardEditorType } from '@apps/ecard/Ecard.types';
import { useTranslation } from '@shared/core';
import { FormikProps } from 'formik';
import { useEffect, useState } from 'react';
import { useEcardsTelemetry } from '@apps/ecard/Ecard.telemetry';
import { EcardType } from '@graphql/generated';
import { useToast } from '@withjoy/joykit';

interface UseEcardEditorControllerArgs
  extends Readonly<{
    formik: FormikProps<EcardDesignInputFields>;
    toggleEcardEditor: () => void;
  }> {}

export const useEcardEditorController = (args: UseEcardEditorControllerArgs) => {
  const { toast } = useToast();
  const { t2, tq } = useTranslation('emailsAndEcards');
  const tEcardEditPanel = t2('ecardEditor', 'ecardEditPanel');
  const { formik, toggleEcardEditor } = args;
  const [selectedEditorType, setSelectedEditorType] = useState<EcardEditorType>(EcardEditorType.DESIGN);
  const telemetry = useEcardsTelemetry();

  useEffect(() => {
    if (!formik.dirty && !formik.isSubmitting) return;
    const preventClose = (e: BeforeUnloadEvent) => e.preventDefault();
    window.addEventListener('beforeunload', preventClose);
    return () => window.removeEventListener('beforeunload', preventClose);
  }, [formik.dirty, formik.isSubmitting]);

  const onSaveClick = async () => {
    try {
      if (formik.dirty || !formik.values.id) {
        await formik.submitForm();
      }
      toast(tEcardEditPanel.doneTooltipText, {
        icon: '✅',
      });
      toggleEcardEditor();
    } catch {
      toast(tq`Something went wrong. Please try again.`, {
        icon: '❌',
      });
    }
    telemetry.editECardDoneClick(formik.values.ecardDraftType as EcardType, selectedEditorType);
  };

  return {
    tEcardEditPanel,
    onSaveClick,
    selectedEditorType,
    setSelectedEditorType,
  };
};
